<template>
  <div>
    <v-btn
      text
      @click="navigate('OssExplain')"
    >
      Home
    </v-btn>

    <v-btn
      text
      @click="navigate('Overview')"
    >
      シナリオ
    </v-btn>

    <v-btn
      text
      @click="navigate('Form')"
    >
      OSSレポジトリを閲覧する
    </v-btn>

    <v-menu
      bottom
      offset-y
      transition="slide-y-transition"
      v-model="menuOpen"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          text
          v-bind="attrs"
          v-on="on"
        >
          機能詳細
        </v-btn>
      </template>

      <v-list>
        <v-list-item
          v-for="(menu, m) in menus"
          :key="m"
        >
          <v-menu
            left
            open-on-hover
            offset-x
            transition="slide-x-reverse-transition"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-container
                class="menuTile"
                text
                v-bind="attrs"
                v-on="on"
                @click="navigate(menu.navi)"
              >
                {{menu.title}}
              </v-container>
            </template>

            <v-list>
              <v-list-item
                v-for="(item, i) in menu.items"
                :key="i"
                @click="navigate(menu.navi, item.section)"
              >
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import router from '../../../router'
export default {
  data: ()=>({
    menuOpen: false,
    menus: [
      {
        title: "管理者",
        navi: "MngRegister",
        items: [
          {title: "管理者登録", section: "manager"},
          {title: "拠点登録", section: "base"},
        ]
      },
      {
        title: "商品販売",
        navi: "Goods",
        items: [
          {title: "商品登録", section: "items"},
          {title: "入庫", section: "add"},
          {title: "売上管理", section: "sales"},
        ]
      },
      {
        title: "仮想通貨発行",
        navi: "Token",
        items: [
          {title: "仮想通貨発行", section: "issue"},
          {title: "預り金管理", section: "obligation"},
        ]
      },
      {
        title: "商品購入",
        navi: "Buy",
        items: [
          {title: "ユーザー登録", section: "user"},
          {title: "商品購入", section: "buy"},
          {title: "購入履歴閲覧", section: "history"},
        ]
      },
      {
        title: "個人間送金",
        navi: "P2p",
        items: [
          {title: "QRコード送金", section: "QR"},
          {title: "シェアリンク送金", section: "link"},
          {title: "送金履歴確認", section: "history"},
        ]
      },
    ],
  }),
  methods: {
    navigate: function(pageName, section){
      if(pageName !== this.$route.name){
        router.push({name: pageName, query: {section: section}})
      }
      this.menuOpen = false;
    }
  }
}
</script>

<style>
.menuTile:hover{
  background: #F8F8F8;
  cursor: pointer;
  width: 100%;
}
</style>